// @generated by protoc-gen-es v2.12.1 with parameter "target=ts"
// @generated from file tabgraph/v1/device.proto (package tabgraph.v1, syntax proto3)
/* eslint-disable */

// Package tabgraph.v1 defines the canonical data types and services for the
// tabgraph application.

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file tabgraph/v1/device.proto.
 */
export const file_tabgraph_v1_device: GenFile = /*@__PURE__*/
  fileDesc("Chh0YWJncmFwaC92MS9kZXZpY2UucHJvdG8SC3RhYmdyYXBoLnYxIpMBCgZEZXZpY2USCgoCaWQYASABKAkSDwoHYnJvd3NlchgCIAEoCRIKCgJvcxgDIAEoCRIwCgxsYXN0X3NlZW5fYXQYBCABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEi4KCmNyZWF0ZWRfYXQYBSABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wQkdaRWdpdGh1Yi5jb20vc3RyYXR1c3N0dWRpb3MvdGFiZ3JhcGgvYmFja2VuZC9nZW4vdGFiZ3JhcGgvdjE7dGFiZ3JhcGh2MWIGcHJvdG8z", [file_google_protobuf_timestamp]);

/**
 * Device represents a browser extension install ("device") registered to a
 * user's account. It backs the Settings "Devices" card.
 *
 * Web extensions cannot read the host machine's hostname or any other
 * machine-identifying value — there is no such API on any engine. `browser`
 * and `os` are the honest maximum: which browser the install is running in
 * and which OS it's running on, with no version/build numbers (there is no
 * reliable cross-engine API for the browser's version short of User-Agent
 * sniffing, which the extension deliberately avoids for browser identity —
 * see extensions/core/src/platform/index.ts).
 *
 * @generated from message tabgraph.v1.Device
 */
export type Device = Message<"tabgraph.v1.Device"> & {
  /**
   * id is the extension-generated per-install identifier.
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * browser is a static per-engine identity supplied by the browser shell,
   * e.g. "Chrome", "Firefox", "Safari". Never derived from the User-Agent
   * string.
   *
   * @generated from field: string browser = 2;
   */
  browser: string;

  /**
   * os is a friendly operating system name derived from
   * `browser.runtime.getPlatformInfo()`, e.g. "macOS", "Windows", "Linux".
   *
   * @generated from field: string os = 3;
   */
  os: string;

  /**
   * last_seen_at is when this device was last active (sign-in or session
   * start).
   *
   * @generated from field: google.protobuf.Timestamp last_seen_at = 4;
   */
  lastSeenAt?: Timestamp | undefined;

  /**
   * created_at is when this device was first registered.
   *
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp | undefined;
};

/**
 * Describes the message tabgraph.v1.Device.
 * Use `create(DeviceSchema)` to create a new message.
 */
export const DeviceSchema: GenMessage<Device> = /*@__PURE__*/
  messageDesc(file_tabgraph_v1_device, 0);

